"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchStore = void 0;
var mobx_1 = require("mobx");
var mobx_utils_1 = require("mobx-utils");
var SearchStore = /** @class */ (function () {
    function SearchStore(searchTermStore, stateQueryStore) {
        var _this = this;
        this.searchTermStore = searchTermStore;
        this.stateQueryStore = stateQueryStore;
        this.selectStates = new Map();
        this.queryLogicOp = new Map();
        this.queryStateLoaded = false;
        this.logicOpForCat = mobx_utils_1.createTransformer(function (categoria) {
            var logicOp = _this.queryLogicOp.get(categoria);
            if (logicOp === undefined) {
                return _this.searchTermStore.getDefaultLogicOpForNombre(categoria);
            }
            ;
            return logicOp;
        });
        mobx_1.autorun(function () {
            mobx_1.transaction(function () {
                _this.selectStates.forEach(function (v, k) {
                    var value = v.map(function (val) { return val.label; });
                    _this.stateQueryStore.setState(k, value);
                });
                _this.queryLogicOp.forEach(function (v, k) {
                    if (v !== _this.searchTermStore.getDefaultLogicOpForNombre(k)) {
                        _this.stateQueryStore.setState(k + "_jt", v);
                    }
                    else {
                        _this.stateQueryStore.deleteKey(k + "_jt");
                    }
                });
            });
        });
        mobx_1.when(function () { return _this.searchTermStore.searchTermsLoaded; }, function () {
            mobx_1.transaction(function () {
                _this.searchTermStore.itemsBusqueda.forEach(function (itemBusqueda) {
                    var state = _this.stateQueryStore.getKey(itemBusqueda.nombre);
                    if (state && state.length > 0) {
                        state.map(function (s) { return _this.searchTermStore.getSearchItemBy(itemBusqueda.nombre, s); })
                            .forEach(function (selectItem) { return selectItem && _this.selectItem(itemBusqueda.nombre, selectItem); });
                    }
                    var logicOpState = _this.stateQueryStore.getKey(itemBusqueda.nombre + "_jt");
                    if (logicOpState && logicOpState.length > 0) {
                        var value = logicOpState[0] === 'y' || logicOpState[0] == 'o' ?
                            logicOpState[0] : _this.searchTermStore.getDefaultLogicOpForNombre(itemBusqueda.nombre);
                        _this.queryLogicOp.set(itemBusqueda.nombre, value);
                    }
                    _this.queryStateLoaded = true;
                });
            });
        });
    }
    SearchStore.getSearchOperator = function (queryType, sourceType, logicOp) {
        // opTable: '`queryType`-`sourceType`-`logicOp`'
        var opTable = {
            'scalar-scalar-y': '$aeq',
            'scalar-scalar-o': '$aeq',
            'scalar-compound-y': '$contains',
            'scalar-compound-o': '$containsAny',
            'compound-scalar-y': '$contains',
            'compound-scalar-o': '$in',
            'compound-compound-y': '$contains',
            'compound-compound-o': '$containsAny',
        };
        return opTable[queryType + "-" + sourceType + "-" + logicOp];
    };
    Object.defineProperty(SearchStore.prototype, "searchExpression", {
        get: function () {
            var e_1, _a, _b, _c;
            var query = {};
            try {
                for (var _d = __values(this.selectStates.entries()), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var categoriaToSelect = _e.value;
                    var categoria = categoriaToSelect[0];
                    var searchItems = categoriaToSelect[1];
                    if (searchItems.length === 0) {
                        continue;
                    }
                    var sourceType = searchItems[0].sourceType;
                    var dbname = searchItems[0].dbname;
                    var queryType = searchItems.length === 1 ? 'scalar' : 'compound';
                    var logicOp = this.logicOpForCat(categoria);
                    var searchOp = SearchStore.getSearchOperator(queryType, sourceType, logicOp);
                    if (queryType === 'scalar') {
                        query[dbname] = (_b = {}, _b[searchOp] = searchItems[0].label, _b);
                    }
                    else {
                        query[dbname] = (_c = {}, _c[searchOp] = searchItems.map(function (si) { return si.label; }), _c);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchStore.prototype, "selectedStatesAsPairs", {
        get: function () {
            var e_2, _a;
            var res = [];
            try {
                for (var _b = __values(this.selectStates.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var catToSelect = _c.value;
                    res.push(catToSelect);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return res;
        },
        enumerable: false,
        configurable: true
    });
    SearchStore.prototype.selectItem = function (category, item) {
        if (mobx_1.isArrayLike(item)) {
            this.selectStates.set(category, Array.from(item));
        }
        else {
            if (item) {
                var selects = this.selectStates.get(category) || [];
                selects.push(item);
                this.selectStates.set(category, selects);
            }
            else {
                // react-select sends a single undefined item if the last option of a category is selected
                // If the category is deleted, serializing doesn't delete this last value, since it's no 
                // longer present in `this.selectStates` but it is present on `stateQueryStore.state`.
                // this sets `category` to the empty array to make serializing behave correctly.
                this.selectStates.set(category, []);
            }
        }
    };
    SearchStore.prototype.maybeFilterToSingle = function (criterio, categoria) {
        var si = this.searchTermStore.getSearchItemBy(categoria, criterio);
        if (si) {
            this.clearAllTerms();
            this.selectStates.set(categoria, [si]);
        }
    };
    SearchStore.prototype.clearAllTerms = function () {
        this.selectStates.forEach(function (_, key, map) { return map.set(key, []); });
    };
    SearchStore.prototype.setQueryJoinType = function (status, categoria) {
        this.queryLogicOp.set(categoria, status);
    };
    SearchStore.prototype.toggleQueryJoinType = function (categoria) {
        var logicOp = this.queryLogicOp.get(categoria);
        if (!logicOp) {
            logicOp = this.searchTermStore.getDefaultLogicOpForNombre(categoria);
        }
        this.queryLogicOp.set(categoria, this.flipLogicOp(logicOp));
    };
    SearchStore.prototype.flipLogicOp = function (logicOp) {
        if (logicOp === 'y')
            return 'o';
        else
            return 'y';
    };
    __decorate([
        mobx_1.observable
    ], SearchStore.prototype, "selectStates", void 0);
    __decorate([
        mobx_1.observable
    ], SearchStore.prototype, "queryLogicOp", void 0);
    __decorate([
        mobx_1.observable
    ], SearchStore.prototype, "queryStateLoaded", void 0);
    __decorate([
        mobx_1.computed
    ], SearchStore.prototype, "searchExpression", null);
    __decorate([
        mobx_1.computed
    ], SearchStore.prototype, "selectedStatesAsPairs", null);
    __decorate([
        mobx_1.action
    ], SearchStore.prototype, "selectItem", null);
    __decorate([
        mobx_1.action
    ], SearchStore.prototype, "maybeFilterToSingle", null);
    __decorate([
        mobx_1.action
    ], SearchStore.prototype, "clearAllTerms", null);
    __decorate([
        mobx_1.action
    ], SearchStore.prototype, "setQueryJoinType", null);
    __decorate([
        mobx_1.action
    ], SearchStore.prototype, "toggleQueryJoinType", null);
    return SearchStore;
}());
exports.SearchStore = SearchStore;
